export default {
    url: '/add',
    template: '<manage-permissions-users-add>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/users/add/index.js